import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// import { DxHttpModule } from 'devextreme-angular/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DxButtonModule, DxTreeViewModule, DxListModule, DxSplitterModule } from 'devextreme-angular';
import { GeneratedReportComponent } from './pages/generated-report/generated-report.component';
import { ReportNotFoundComponent } from './pages/report-not-found/report-not-found.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { PivotGridModule } from './shared/components';
import { MetaDataModule } from './shared/services'
import { PivotGridConfigResolver, ReportsResolver } from './shared/resolvers';
import { HelpComponent } from './pages/help/help.component';
import { HelpTextComponent } from './pages/help/help-text/help-text.component';

const routes: Routes = [
  {
    path: 'help',
    component: HelpComponent,
  },
  {
    path: 'reports',
    component: ReportsComponent,
    resolve: {
      reports: ReportsResolver,
    },
  },
  {
    path: 'generated-report/:reportId',
    component: GeneratedReportComponent,
    resolve: {
      pivotGridConfig: PivotGridConfigResolver,
    },
  },
  {
    path: 'report-not-found',
    component: ReportNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'reports',
  },
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    // DxHttpModule,
    RouterModule.forRoot(routes, { useHash: true }),
    DxButtonModule,
    PivotGridModule,
    MetaDataModule,
    DxTreeViewModule,
    DxSplitterModule,
    DxListModule,
  ],
  exports: [RouterModule, PivotGridModule, DxListModule, MetaDataModule],
  declarations: [GeneratedReportComponent, ReportNotFoundComponent, ReportsComponent, HelpComponent, HelpTextComponent],
  // providers: [provideHttpClient()],
})
export class AppRoutingModule {}
